import React from 'react';
export const SpaceContext = /*#__PURE__*/React.createContext({
  latestIndex: 0
});
export const SpaceContextProvider = SpaceContext.Provider;